<template>
  <div class="modal fade " tabindex="-1" role="dialog" id="modalNewRecap">
    <div class="modal-dialog">
      <div class="modal-content" v-if="newRecap">

        <div class="overlay ModalOverlay" v-if="loading">
          <i class="fa fa-refresh fa-spin"></i>
        </div>

        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">×</span></button>
          <h4 class="modal-title"> Ajouter un récapitulatif</h4>
        </div>

        <div class="modal-body">

          <div class="form-group">
            <label for="statut">Statut actuel</label>
            <select id="statut" class="form-control" name="recap[statut]"
                    v-model="newRecap.statut.id">
              <option
                v-for="statut in getStatusRecap"
                :value="statut.id"
              > {{ statut.type }}
              </option>
            </select>
            <!--<span class="help-block">Help block with error</span>-->
          </div>

          <div class="form-group"
               :class="{'has-error': errors.has('recap[date]') }">
            <label>Date d'entrée du récapitulatif</label>
            <div class="input-group date">
              <div class="input-group-addon">
                <i class="fa fa-calendar"></i>
              </div>
              <masked-input type="text"
                            disabled
                            v-model="newRecap.date"
                            v-validate="'required|date_format:DD/MM/YYYY'"
                            :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                            :guide="true"
                            :keepCharPositions="true"
                            :showMask="true"
                            name="recap[date]"
                            class="form-control pull-right datepicker"
                            id="datepicker2">
              </masked-input>
            </div>
            <span v-show="errors.has('recap[date]')"
                  class="help-block">Date incorrecte</span>
          </div>

          <list-select-club
            :clubsLicenciesUniquement="true"
            title="Club"
            :clubPreSelected="null"
            @clubSelected="updateClubSelected"
          ></list-select-club>

          <b-alert variant="danger"
                   class="col-md-12"
                   v-if="recapsUnpayedByClub.length>0"
                   show>
            <div class="pull-left">
              Ce club a un ou plusieurs récapitulatifs impayés:
              <ul>
                <li v-for="recap in recapsUnpayedByClub">
                  <a href="#"
                     @click="goToRecap(recap.id)"
                  >
                    Récapitulatif n°{{ recap.id |idFormat }}
                  </a>
                </li>
              </ul>
            </div>
          </b-alert>

          <div class="form-group"
               :class="{'has-error': errors.has('recap[comment]') }">
            <label for="nom">Commentaire</label>
            <textarea type="text" class="form-control" id="nom" name="recap[comment]"
                      v-validate="'max:255'"
                      placeholder=""
                      v-model="newRecap.comment">{{newRecap.comment}}</textarea>
            <span v-show="errors.has('recap[comment]')" class="help-block">Le commentaire doit comporter moins de 255 caractères</span>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default pull-left" data-dismiss="modal">
            Fermer
          </button>
          <button type="button"
                  class="btn btn-primary"
                  :disabled="errors.count()!=0 || this.newRecap.id_club==0 || this.disabledBtn || this.loadingInputs.length>0"
                  @click="addRecap()"
          >
            Ajouter un récapitulatif
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import ListSelectClub from '../../Communs/listeSelectClub'

var $ = require('jquery');
var _ = require('underscore')
var moment = require('moment')

export default {
  data() {
    return {
      loadingInputs: [],
      disabledBtn: false,
      newRecap: null,
      loading: false,
      recapsUnpayedByClub: [],
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getStatusRecap: 'getStatusRecap',
      getTextesRecap: 'getTextesRecap',
      getRecap: 'getRecap'
    }),
  },
  mounted: function () {
    var these = this
    this.newForm()
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  watch: {},
  components: {
    ListSelectClub,
  },
  methods: {
    ...mapActions({}),
    newForm() {
      this.newRecap = {
        statut: {id: 6},
        date: moment().format('DD/MM/YYYY'),
        id_club: 0,
        comment: ""
      }
    },
    goToRecap: function (recapId) {
      this.closeModal();
      this.$router.push({name: 'Recap', params: {recap_id: recapId}});
    },
    closeModal: function () {
      $('#modalNewRecap').modal('hide')
    },
    addRecap: function () {
      this.disabledBtn = true;
      let self = this;
      this.$http.post(this.getRoute('Secretariat.recapitulatif.store'), this.constructForm()).then(function (response) {
        self.$noty.success("Le récapitulatif a bien été créé")
        self.disabledBtn = false
        self.$router.push({name: 'Recap', params: {recap_id: response.body.id}})
        self.closeModal();
      }, (response) => {
        self.$noty.error("Erreur dans la création du nouveau récapitulatif")
        self.disabledBtn = false
        self.closeModal();
      });
    },
    updateClubSelected: function (value) {
      console.log(value)
      this.newRecap.id_club = value.id;
      this.checkIfClubHasRecapUnpayed(value.id)
    },
    checkIfClubHasRecapUnpayed: function (idClub) {
      this.disabledBtn = true;
      let self = this;
      this.$http.post(this.getRoute('Secretariat.recapitulatif.getRecapsForOneClubByStatut'), {
        id_club: idClub,
        statut: ["pending", "wait_pay"]
      }).then((response) => {
        self.recapsUnpayedByClub = response.body && response.body.length > 0 ? response.body : []
        self.disabledBtn = false
      }, (response) => {
        self.recapsUnpayedByClub = []
        self.$noty.error("Erreur dans la requête")
        self.disabledBtn = false
      });
    },
    currentYear: function () {
      return moment().year();
    },
    console: function (event) {
      console.log(event);
    },
    constructForm: function () {
      return JSON.stringify({
        "statut": this.newRecap.statut.id,
        "date": this.newRecap.date,
        "comment": this.newRecap.comment,
        "id_club": this.newRecap.id_club,
      })
    },
    formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
      if (value == null) return ''
      return moment(value, fmtIn).format(fmtOut)
    },
    isInputLoading: function (input) {
      return _.indexOf(this.loadingInputs, input) >= 0 ? true : false
    },
    addToLoadingInputs: function (input) {
      this.loadingInputs.push(input)
    },
    removeFromLoadingInputs: function (input) {
      this.loadingInputs = _.without(this.loadingInputs, input)
    },
  },
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Recapitulatif/ModalNewRecap.vue